var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-container"},[_c('span',[_vm._v("© 2019 - Angle")])])
}]

export { render, staticRenderFns }